/*

{
  identifier: {
    pk: LIBRARY_TYPE#{libraryType}#LIBRARY#{libraryId}
    sk: STATE#{state}#LIBRARY_TYPE#{libraryType}#LIBRARY#{libraryId}#DATA
  },
  libraryType: | user, team, org, case |
  libraryId: | userId, teamId, orgId, caseId |
  libraryName: string
}

*/

const { DataTableBase } = require('./base.class');
const { identifiers } = require('../datastructComponents');
const Joi = require('joi');
const { STATES, LIBRARY_TYPES } = require('@bcm/constants');

const schema = {
  state: Joi.string().valid( ...Object.keys(STATES) ).required(),
  libraryType: Joi.string().valid( ...Object.keys(LIBRARY_TYPES) ).required(),
  libraryId: Joi.string().required(),
  libraryName: Joi.string().required(),
};

class Library extends DataTableBase {
  constructor ( obj ) {
    super(
      identifiers.library.buildPk(obj.libraryId),
      identifiers.library.buildSk(obj.state, obj.libraryType, obj.libraryId)
    );
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Library = Library;
exports.librarySchema = schema;